export const processSite = param => {
  let tmp = ''
  if( ( param.indexOf( 'localhost' ) !== -1 ) || param.indexOf( '127.0.0.1' ) !== -1 ) {
    tmp = 'ufit-staging.techbasemlm.com'
  } else {
    tmp = `${ param }`
  }
  return tmp
}